import { List, Map } from 'immutable';
import escapeStringRegexp from 'escape-string-regexp';
import { webpackPromiseDispatchLoader } from '@artsman/ams-loader';

import { DIRECTOR_CHANNEL_PREFIX, DIRECTOR_CHANNEL_DELIMITTER, DEFAULT_API_FILTER_NAME } from './constants';
import { config } from './config';
import { getSchemaModelLoader } from './schemaLoader';

const API_V1_PREFIX = config.getApiBaseUrl();

const endpoints = Map({
  me: API_V1_PREFIX + '/me',

  dashboard_layouts: API_V1_PREFIX + '/dashboard_layouts',
  widget_types: API_V1_PREFIX + '/widget_types',
  dashboard_links: API_V1_PREFIX + '/dashboard_links',
  widget_links: API_V1_PREFIX + '/widget_links',
  dashboards: API_V1_PREFIX + '/dashboards',
  dashboardsNew: API_V1_PREFIX + '/dashboards/new',
  widgets: API_V1_PREFIX + '/widgets',

  index: API_V1_PREFIX,
  address_links: API_V1_PREFIX + '/address_links',
  addresses: API_V1_PREFIX + '/addresses',
  assigned_report_cards: API_V1_PREFIX + '/assigned_report_cards',
  calendar_events: API_V1_PREFIX + '/calendar_events',
  calendar_filters: API_V1_PREFIX + '/calendar_filters',
  cart_details: API_V1_PREFIX + '/cart_details',
  carts: API_V1_PREFIX + '/carts',
  city_lookup: API_V1_PREFIX + '/city_lookup',
  comments: API_V1_PREFIX + '/comments',
  commissions: API_V1_PREFIX + '/commissions',
  contact_links: API_V1_PREFIX + '/contact_links',
  contact_schedules: API_V1_PREFIX + '/contact_schedules',
  contacts: API_V1_PREFIX + '/contacts',
  correspondence: API_V1_PREFIX + '/correspondence',
  correspondence_links: API_V1_PREFIX + '/correspondence_links',
  coupon_headers: API_V1_PREFIX + '/coupon_headers',
  currency_conversions: API_V1_PREFIX + '/currency_conversions',
  daily_sales_summaries: API_V1_PREFIX + '/daily_sales_summaries',
  daily_usage: API_V1_PREFIX + '/daily_usage',
  documents: API_V1_PREFIX + '/documents',
  donation_campaigns: API_V1_PREFIX + '/donation_campaigns',
  donation_receipts: API_V1_PREFIX + '/donation_receipts',
  donations: API_V1_PREFIX + '/donations',
  donor_search: API_V1_PREFIX + '/donor_search',
  employees: API_V1_PREFIX + '/employees',
  events: API_V1_PREFIX + '/events',
  execution_logs: API_V1_PREFIX + '/execution_logs',
  fee_types: API_V1_PREFIX + '/fee_types',
  fees: API_V1_PREFIX + '/fees',
  giving_level_details: API_V1_PREFIX + '/giving_level_details',
  giving_level_summaries: API_V1_PREFIX + '/giving_level_summaries',
  giving_levels: API_V1_PREFIX + '/giving_levels',
  gl_accounts: API_V1_PREFIX + '/gl_accounts',
  gl_details: API_V1_PREFIX + '/gl_details',
  gl_headers: API_V1_PREFIX + '/gl_headers',
  households: API_V1_PREFIX + '/households',
  jobs: API_V1_PREFIX + '/jobs',
  mail_list_links: API_V1_PREFIX + '/mail_list_links',
  mail_lists: API_V1_PREFIX + '/mail_lists',
  maps: API_V1_PREFIX + '/maps',
  marketing: API_V1_PREFIX + '/marketing',
  member_assigned_cards: API_V1_PREFIX + '/member_assigned_cards',
  member_cards: API_V1_PREFIX + '/member_cards',
  membership_types: API_V1_PREFIX + '/membership_types',
  memberships: API_V1_PREFIX + '/memberships',
  merchants: API_V1_PREFIX + '/merchants',
  notifications: API_V1_PREFIX + '/notifications',
  orders: API_V1_PREFIX + '/orders',
  outlets: API_V1_PREFIX + '/outlets',
  package_details: API_V1_PREFIX + '/package_details',
  package_headers: API_V1_PREFIX + '/package_headers',
  patron_assets: API_V1_PREFIX + '/patron_assets',
  patrons: API_V1_PREFIX + '/patrons',
  payments: API_V1_PREFIX + '/payments',
  performances: API_V1_PREFIX + '/performances',
  plugins: API_V1_PREFIX + '/plugins',
  press: API_V1_PREFIX + '/press',
  price_codes: API_V1_PREFIX + '/price_codes',
  project_holidays: API_V1_PREFIX + '/project_holidays',
  project_markers: API_V1_PREFIX + '/project_markers',
  project_relations: API_V1_PREFIX + '/project_relations',
  project_suspensions: API_V1_PREFIX + '/project_suspensions',
  project_working_hours: API_V1_PREFIX + '/project_working_hours',
  promotions: API_V1_PREFIX + '/promotions',
  recognition_details: API_V1_PREFIX + '/recognition_details',
  recognitions: API_V1_PREFIX + '/recognitions',
  relationships: API_V1_PREFIX + '/relationships',
  report_card_details: API_V1_PREFIX + '/report_card_details',
  report_card_template_details: API_V1_PREFIX + '/report_card_template_details',
  report_card_templates: API_V1_PREFIX + '/report_card_templates',
  report_cards: API_V1_PREFIX + '/report_cards',
  resource_assemblies: API_V1_PREFIX + '/resource_assemblies',
  resource_links: API_V1_PREFIX + '/resource_links',
  resources: API_V1_PREFIX + '/resources',
  sales_rule_details: API_V1_PREFIX + '/sales_rule_details',
  sales_rules: API_V1_PREFIX + '/sales_rules',
  seasons: API_V1_PREFIX + '/seasons',
  seating_preferences: API_V1_PREFIX + '/seating_preferences',
  seats: API_V1_PREFIX + '/seats',
  security_access: API_V1_PREFIX + '/security_access',
  security_endpoints: API_V1_PREFIX + '/security_endpoints',
  statistics: API_V1_PREFIX + '/statistics',
  subscriptions: API_V1_PREFIX + '/subscriptions',
  supervisors: API_V1_PREFIX + '/supervisors',
  system: API_V1_PREFIX + '/system',
  task_participants: API_V1_PREFIX + '/task_participants',
  tax_rates: API_V1_PREFIX + '/tax_rates',
  ticket_faces: API_V1_PREFIX + '/ticket_faces',
  tickets: API_V1_PREFIX + '/tickets',
  transactions: API_V1_PREFIX + '/transactions',
  venues: API_V1_PREFIX + '/venues',
  volunteer_availabities: API_V1_PREFIX + '/volunteer_availabities',
  volunteer_billing_details: API_V1_PREFIX + '/volunteer_billing_details',
  volunteer_history: API_V1_PREFIX + '/volunteer_history',
  volunteers: API_V1_PREFIX + '/volunteers',
  web_logs: API_V1_PREFIX + '/web_logs'
});

export function getEndpoint({ dataSource }) {
  return endpoints.get(dataSource);
}

/*
   Load model in the "WebPack way" for code splitting.  To do code splitting a static analysis is done on this
   function to substitute in the right module name.

   WebPack Docs: https://webpack.js.org/guides/code-splitting-require/#require-ensure-

   NOTE: 3rd argument to require.ensure, for errors, requires the webpack error handling plugin.
         (https://github.com/richardscarrott/require-error-handler-webpack-plugin)
 */
function loadModel(modelName) {
  return () => new Promise((resolve, reject) => {
    require.ensure(
        [],
        require => { resolve(require("./models/" + modelName).default) },
        error => { reject(error) },
        "dataSources"
    );
  });
}


const moduleLoaders = Map({
  me: loadModel('me'),

  dashboard_layouts: loadModel('dashboard_layouts'),
  widget_types: loadModel('widget_types'),
  dashboard_links: loadModel('dashboard_links'),
  widget_links: loadModel('widget_links'),
  dashboards: loadModel('dashboards'),
  dashboardsNew: loadModel('dashboards_new'),
  widgets: loadModel('widgets')
});

const moduleLoader = webpackPromiseDispatchLoader(moduleLoaders);

function getModelLoader(dataSource, declaration, options) {
  if (moduleLoaders.get(dataSource)) {
    return moduleLoader(dataSource, declaration, options);
  }
  else {
    return getSchemaModelLoader(dataSource, declaration, options, getEndpoint);
  }
}

export function loader(dataSource, declaration, options) {
  let { group } = options;
  if (group !== undefined) {
    return getSchemaModelLoader(dataSource, declaration, options, getEndpoint);
  } else {
    return getModelLoader(dataSource, declaration, options);
  }
}

/*
 * DEV NOTE: Since channels are directly mapped to API endpoint names, and there are no filters, just
 *           generate all the channel names from the map of endpoints.
 */
const apiPrefixRE = new RegExp(escapeStringRegexp(API_V1_PREFIX));
const includeRE = new RegExp('\\?include=(.*)');
const slashReplaceRE = new RegExp(escapeStringRegexp('/'));

export function getEndpointAndIncludes(endpointAndIncludes) {
  let endpoint = endpointAndIncludes;
  let includes = [];
  let matches = endpointAndIncludes.match(includeRE);
  if (matches) {
    endpoint = endpointAndIncludes.substring(0, matches.index);
    includes = matches[1].split('+');
  }
  return {
    endpoint,
    includes
  }
}

function createChannel(endpoint) {
  let path = endpoint.replace(apiPrefixRE, '');

  let { endpoint: endpointPath, includes } = getEndpointAndIncludes(path);

  // includes is an array of the include=?<a>+<b> parts, ready to be passed to the socket.

  return config.getSocketBaseChannel() + endpointPath.replace(slashReplaceRE, config.getSocketDelimiter())
}

function createChannels(endpoints) {
  let channels = {};
  endpoints.forEach( (endpoint, dataSource) => {
    channels[dataSource] = Map({[DEFAULT_API_FILTER_NAME]: List([createChannel(endpoint)])});
  });
  return Map(channels);
}

export const channels = createChannels(endpoints);
